import { Market } from 'BrokerTsLib/src/enums'
import type { IPartnerSettings } from '.'

const hosts = [
  'broker-new.cebia.cz'
  , 'broker.cebia.cz'
  // , 'localhost:44470'
]

export const BmwFs: IPartnerSettings = {
  partner: 'BMWFS',
  hosts,
  market: Market.CZ
}

export const BMWFSSK: IPartnerSettings = {
  partner: 'BMWFSSK',
  hosts: hosts,
  market: Market.SK
}